export const dayNames = ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"]
export const dayShortNames = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]